import React from 'react';

import classNames from 'classnames';
import { useTranslations } from 'next-intl';

import { APIRequestError } from '@/api/fetchers/APIRequestError';
import typography from '@/styles/typography.module.scss';

import styles from '@/app/[lang]/converters/sections/CurrencyConverter/styles.module.scss';

export function ErrorMessage({
  error,
  fromCurrency,
  toCurrency,
}: {
  error: APIRequestError;
  fromCurrency: any;
  toCurrency: any;
}) {
  const tr = useTranslations();

  if (!error) {
    return null;
  }

  if (
    typeof error?.response?.status === 'number' &&
    error.response.status >= 400 &&
    error.response.status < 500
  ) {
    return (
      <p className={classNames(styles.errorMessage, typography.bodyM)}>
        {tr.rich('pages.converters.index.sections.converterFields.error', {
          fromCurrency: (_) => <span className={typography.semibold}>{fromCurrency}</span>,
          toCurrency: (_) => <span className={typography.semibold}>{toCurrency}</span>,
        })}
      </p>
    );
  }

  return <p className={classNames(styles.errorMessage, typography.bodyM)}>API error</p>;
}
